<div class="flex h-full">
    <div class="self-center">
        <app-alert [title]="settings.title" [type]="settings.type">
            <p class="text-justify">
                {{ settings.body }}
            </p>
            <ng-container app-alert-footer>
                <button
                    type="button"
                    mat-flat-button
                    mat-dialog-close
                    [class.button-bg-green-50]="settings.type == 'success'"
                    [class.button-bg-yellow-50]="settings.type == 'warn'"
                    [class.button-bg-red-50]="settings.type == 'error'"
                    [class.button-bg-blue-50]="settings.type == 'info'"
                >
                    <mat-icon class="mr-1" svgIcon="heroicons_outline:cancel_circle"></mat-icon>
                    Cerrar
                </button>
            </ng-container>
        </app-alert>
    </div>
</div>
